import React from 'react'
import styled from 'styled-components'
import { Tooltip } from 'antd'
import RejectIcon from '../../../../../components/icons/DriveTableIcon/Reject'
import RescheduleIcon from '../../../../../components/icons/DriveTableIcon/Reschedule'
import ShortlistIcon from '../../../../../components/icons/DriveTableIcon/Shortlist'

import HoldBlackIcon from '../../../../../components/icons/DriveTableIcon/HoldBlack'
import HoldYellowIcon from '../../../../../components/icons/DriveTableIcon/HoldYellow'
import { EmptyElement } from '../../../../../components/UIComponents/CommonStyledDiv'
import ResumeDownload from '../../../../../components/icons/DriveTableIcon/ResumeDownload'
import { Divider } from 'antd'
import Button from 'components/Button'

const IconContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  gap: 20px;
  cursor: pointer;
  margin-top: 5px;
  width: 100%;
`

const IconText = styled.h4`
  margin-bottom: 6px;

  color: rgba(128, 134, 151, 1);
`
const StyledRescheduleIcon = styled.div`
  margin-top: 4px;
`
const StyledDivider = styled(Divider)`
  margin: 0 10px;
  border-color: rgba(223, 223, 223, 1);
  height: 40px;
  align-self: center;
`

// Helper function to count active filter categories
const getActiveFilterCount = (filterValues) => {
  if (!filterValues) return 0;
  
  let activeCount = 0;
  
  // Check array type filters
  const arrayFilters = [
    'selectedRound', 'selectedStatus', 'selectedDegrees', 'selectedDepartments', 
    'selectedSpecializations', 'selectedYears', 'selectedSkills', 'selectedColleges', 
    'selectedCollegeStates', 'selectedCollegeCities', 'selectedGender', 'selectScories',
    'selectedRoundScore', 'selectedQualifyingQuestions', 'selectedPermanentState', 
    'selectedPermanentCity', 'selectedCurrentState', 'selectedCurrentCity', 
    'selectedPreferredLocation', 'selectedFunction', 'selectedRole', 
    'selectedDurationYear', 'selectedDurationMonth'
  ];
  
  arrayFilters.forEach(filter => {
    if (Array.isArray(filterValues[filter]) && filterValues[filter].length > 0) {
      activeCount++;
    }
  });
  
  // Check object type filters
  if (filterValues.selectedAge && (filterValues.selectedAge.from || filterValues.selectedAge.to)) {
    activeCount++;
  }
  
  if (filterValues.selectedQuickAge && (filterValues.selectedQuickAge.from || filterValues.selectedQuickAge.to)) {
    activeCount++;
  }
  
  // Check other specific filters
  if (filterValues.selectedScoreFilterType) activeCount++;
  if (filterValues.selectedCurrentArrearFilterType) activeCount++;
  if (filterValues.selectedPastArrearFilterType) activeCount++;
  if (filterValues.selectedCurrentArrearCount !== null && filterValues.selectedCurrentArrearCount !== undefined) activeCount++;
  if (filterValues.selectedPastArrearCount !== null && filterValues.selectedPastArrearCount !== undefined) activeCount++;
  if (filterValues.includeArrears) activeCount++;
  
  return activeCount;
};

function TableStatusIcon({
  status,
  stage,
  onChange,
  round,
  candidateStatus,
  selectedCandidateId,
  handleDownload,
  conflictData,
  handleResolveConflict,
  filterValues,
  setSelectAssessmentDrawerOpen
}) {
  return (
    <IconContainer>
      <div style={{ display: 'flex', alignItems: 'center', gap: '20px' }}>
        <IconText style={{ whiteSpace: 'nowrap' }}>Select status</IconText>
              {status !== 'ABSENT' && status !== 'ACCEPTED' && (
        <Tooltip
          title="Shortlist"
          placement="top"
        >
          <EmptyElement
            onClick={
              [
                'SHORTLISTED',
              ]?.some(value => candidateStatus?.includes(value)) ||
              selectedCandidateId?.length == 0
                ? undefined
                : () => onChange('SHORTLISTED')
            }
            style={{
              pointerEvents: 'auto',
              opacity:
                [
                  'SHORTLISTED',
                ]?.some(value => candidateStatus?.includes(value)) ||
                selectedCandidateId?.length == 0
                  ? '0.5'
                  : '',
            }}
          >
            <ShortlistIcon />
          </EmptyElement>
        </Tooltip>
        )}
              {status != 'REJECTED' && status !== 'ABSENT' && (
        <Tooltip
          title="Reject"
          placement="top"
        >
          <EmptyElement
            onClick={
              ['REJECTED',]?.some(
                value => candidateStatus?.includes(value)
              ) || selectedCandidateId?.length == 0
                ? undefined
                : () => onChange('REJECTED')
            }
            style={{
              pointerEvents: 'auto',
              opacity:
                ['REJECTED', 'TO_BE_UPDATED']?.some(
                  value => candidateStatus?.includes(value)
                ) || selectedCandidateId?.length == 0
                  ? '0.5'
                  : '',
            }}
          >
            <RejectIcon />
          </EmptyElement>
        </Tooltip>
      )}
              {status != 'HELD_TO_COMPARE' &&
       round !== 'CV_SCREENING' &&
          status !== 'ABSENT' &&
          stage !== 'offer' && (
          <Tooltip
            title="Hold to Compare"
            placement="top"
          >
            <EmptyElement
              onClick={
                [
                  'ABSENT',
                  'HELD_TO_COMPARE',
                  'SHORTLISTED'
                ]?.some(value => candidateStatus?.includes(value)) ||
                selectedCandidateId?.length == 0
                  ? undefined
                  : () => onChange('HELD_TO_COMPARE')
              }
                          style={{
              pointerEvents: 'auto',
              opacity:
                [
                  'ABSENT',
                  'HELD_TO_COMPARE',
                  'SHORTLISTED'
                ]?.some(value => candidateStatus?.includes(value)) ||
                selectedCandidateId?.length == 0
                  ? '0.5'
                  : '',
            }}
            >
              <HoldYellowIcon />
            </EmptyElement>
          </Tooltip>
        )}
              {stage !== 'offer' &&
        round !== 'CV_SCREENING' &&
          round !== 'ASSESMENT' &&
          round !== 'EXTERNAL_ASSESMENT' && (
          <Tooltip
            title="Reschedule"
            placement="top"
          > 
            <EmptyElement
              onClick={
                ['TO_BE_SCHEDULED', 'RESCHEDULED']?.some(
                  value => candidateStatus?.includes(value)
                ) || selectedCandidateId?.length == 0
                  ? undefined
                  : () => onChange('RESCHEDULE')
              }
                          style={{
              pointerEvents: 'auto',
              opacity:
                ['TO_BE_SCHEDULED', 'RESCHEDULED']?.some(
                  value => candidateStatus?.includes(value)
                ) || selectedCandidateId?.length == 0
                  ? '0.5'
                  : '',
            }}
            >
              <StyledRescheduleIcon>
                <RescheduleIcon />
              </StyledRescheduleIcon>
            </EmptyElement>
          </Tooltip>
        )}

              {status !== 'ABSENT' &&
          round !== 'CV_SCREENING' &&
          stage !== 'offer' &&
          round !== 'ASSESMENT' &&
          round !== 'EXTERNAL_ASSESMENT' && (
          <Tooltip
            title="Absent"
            placement="top"
          >
            <EmptyElement
              onClick={
                ['TO_BE_UPDATED']?.some(value =>
                  candidateStatus?.includes(value)
                ) || selectedCandidateId?.length == 0
                  ? undefined
                  : () => onChange('ABSENT')
              }
                          style={{
              pointerEvents: 'auto',
              opacity:
                ['TO_BE_UPDATED']?.some(value =>
                  candidateStatus?.includes(value)
                ) || selectedCandidateId?.length == 0
                  ? '0.5'
                  : '',
            }}
            >
              <HoldBlackIcon />
            </EmptyElement>
          </Tooltip>
        )}
                  
        <>
          <StyledDivider type="vertical" />
          <EmptyElement
            onClick={
              selectedCandidateId?.length == 0
                ? undefined
                : () => handleDownload()
            }
            style={{
              pointerEvents: 'auto',
              opacity:
                selectedCandidateId?.length == 0
                  ? '0.5'
                  : '',
            }}
          >
            <ResumeDownload />
          </EmptyElement>

          {filterValues && getActiveFilterCount(filterValues) > 0 && (
            <>
              <StyledDivider type="vertical" />
              <IconText style={{ whiteSpace: 'nowrap' }}>Selected Filter Count: {getActiveFilterCount(filterValues)}</IconText>
            </>
          )}
        </>
      </div>
      <div 
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-end',
        gap: '10px',
        flex: '0 0 auto',
        marginRight: '10px',
        marginBottom: '5px',
      }}
      >

        { stage !== 'all_candidates' && stage !== 'offer'  && (
                            <Button.Secondary
                              wordBreak
                              text={'+ Select Assessment'}
                              onClick={() => setSelectAssessmentDrawerOpen(true)}
                            />
        )}
        <Button.Danger
        wordBreak
        text={'Resolve Conflicts'}
        onClick={() => handleResolveConflict()}
        disable={conflictData?.count === 0}
      />
     
      </div>
     
    </IconContainer>
  )
}

export default TableStatusIcon
